import Request from '@request/Request';
import Model from '@models/Project';

export default class extends Request {
  constructor(validationObserver, data = {}) {
    data = {
      ...Model.data(),
      ...data,
    };
    super(validationObserver, data);
    this.model = new Model();
  }

  async submit() {
    this.beforeSubmit();
    try {
      let response = await this.model.save(this.data());
      $showSuccess(response.message, 'project-toast');
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }
}
